// https://juejin.cn/post/6844903697999200263
import { defineComponent, computed } from 'vue';
export default defineComponent({
  name: 'BaseSvg',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },

  setup(props) {
    const iconName = computed(() => '#icon-' + props.iconClass);
    const svgClass = computed(() => 'svg-icon' + (props.className ? props.className : ''));
    return {
      iconName,
      svgClass
    };
  }

});